import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgTransferDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgTransfer = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        x="0"
        y="0"
        width="16"
        height="16"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="currentColor"
          d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="currentColor"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        />
      </g>
      <path
        fill="#fff"
        d="M5.905 8.705 5.2 8l-2 2 2 2 .705-.705-.79-.795H12.7v-1H5.115zm4.59-1.41L11.2 8l2-2-2-2-.705.705.79.795H3.7v1h7.585z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
      <filter
        id="d"
        width={22.857}
        height={22.857}
        x={-3.429}
        y={-2.857}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.571} />
        <feGaussianBlur stdDeviation={1.714} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8052_39312" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_8052_39312" result="shape" />
      </filter>
    </defs>
  </svg>
));
